import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({

  state: {
    pages: [],
    projects: [],
    navLinkIsHovered: false,
    globalLinkIsHovered: false,
  },

  mutations: {
    SET_PROJECTS(state, projects) {
      state.projects = projects
    },

    SET_PAGES(state, pages) {
      state.pages = pages
    },

    SET_NAV_LINK_IS_HOVERED(state, hovered) {
      state.navLinkIsHovered = hovered
    },

    SET_GLOBAL_LINK_IS_HOVERED(state, hovered) {
      state.globalLinkIsHovered = hovered
    }
  },

  modules: {
  }
});

export default store;
